"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getHitTimestamp = () => {
    const date = new Date();
    const day = getNumberLength(date.getUTCDate()) === 1
        ? `0${date.getUTCDate()}`
        : date.getUTCDate();
    let month = date.getUTCMonth() + 1;
    month = getNumberLength(month) === 1 ? `0${month}` : month;
    const year = date.getUTCFullYear();
    const hour = getNumberLength(date.getUTCHours()) === 1
        ? `0${date.getUTCHours()}`
        : date.getUTCHours();
    const minutes = getNumberLength(date.getUTCMinutes()) === 1
        ? `0${date.getUTCMinutes()}`
        : date.getUTCMinutes();
    const seconds = getNumberLength(date.getUTCSeconds()) === 1
        ? `0${date.getUTCSeconds()}`
        : date.getUTCSeconds();
    const milliseconds = () => {
        if (getNumberLength(date.getUTCMilliseconds()) < 3) {
            return getNumberLength(date.getUTCMilliseconds()) === 1
                ? `00${date.getUTCMilliseconds()}`
                : `0${date.getUTCMilliseconds()}`;
        }
        return date.getUTCMilliseconds();
    };
    return `${day}/${month}/${year} ${hour}:${minutes}:${seconds}:${milliseconds()}`;
};
const getNumberLength = (number) => number.toString().length;
exports.default = getHitTimestamp;
